import { energyGainApi } from "../../../services/energyGainApi";
import dayjs from "dayjs";
import type { EnergyReading, FetchMeterReadingsRequest, TreeItemDataList } from "./dashboardTypes";
import type { MonthReading } from "../components/ForecastActualVsPredicted/ForecastChart";

const dashboardEndpoints = energyGainApi.injectEndpoints({
  endpoints: (builder) => ({
    getTreeData: builder.query<TreeItemDataList, { search?: string; sort?: string }>({
      query: (queryArg) => ({
        url: "/api/dashboard/hierarchical-data/",
        params: {
          search: queryArg.search,
          sort: queryArg.sort,
          limit: 20,
        },
      }),
      providesTags: ["TreeData"],
    }),
    fetchMeterReadings: builder.query<EnergyReading[], FetchMeterReadingsRequest>({
      query: (params) => ({ url: "/api/meters/meter-readings/report", params }),
    }),
    getEnergyOverview: builder.query<EnergyReading[], { entity_id?: string; entity_name?: string }>({
      query: ({ entity_id, entity_name }) => {
        const today = dayjs().tz();
        return {
          url: "/api/meters/meter-readings/report",
          params: {
            from_date: today.format("YYYY-MM-DD"),
            to_date: today.add(1, "day").format("YYYY-MM-DD"),
            entity_id: entity_id,
            entity_name: entity_name,
            aggregation_level: "daily",
          },
        };
      },
    }),
    getForecastComparison: builder.query<MonthReading[], { meter_id: number; reading_type?: string }>({
      query: ({ meter_id, reading_type }) => ({
        url: "/api/meters/forecast",
        params: { meter_id, reading_type },
      }),
      providesTags: (_result, _error, { meter_id }) => [{ type: "ForecastComparison", id: `${meter_id}` }],
    }),
  }),
});

export const {
  useGetTreeDataQuery,
  useFetchMeterReadingsQuery,
  useGetEnergyOverviewQuery,
  useGetForecastComparisonQuery,
} = dashboardEndpoints;
